import { useState } from "react";
import { api } from "../../../../../utility/api";

export const ProduccionV2Api = () => {
    const [cargando, setCargando] = useState(false);

    const getMetricasPaletizacionTurno = async () => {
        try {
            setCargando(true);
            const response = await api.get(
                "paletizacion/metricas_paletizacion_turno",
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const getDetallePaletizacion = async (idPaletizacion) => {
        try {
            setCargando(true);

            const response = await api.get(`paletizacion/${idPaletizacion}`);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const getTurnoActual = async () => {
        try {
            setCargando(true);

            const response = await api.get(`turnos_produccion/turno_actual`);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const completarOrdenProduccion = async (idOrden) => {
        try {
            setCargando(true);
            const response = await api.post(
                `produccion_v2/completar_orden_produccion/${idOrden}`,
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const reabrirPaletizacion = async () => {
        try {
            setCargando(true);
            const response = await api.post("paletizacion/reabrir_paletizacion");
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const getEVSProduccion = async (params) => {
        return api
            .get("evs", params)
            .then((data) => {
                if (data) return data.results;
                return [];
            })
            .catch(() => {
                return [];
            });
    };

    return {
        getMetricasPaletizacionTurno,
        getDetallePaletizacion,
        getTurnoActual,
        completarOrdenProduccion,
        reabrirPaletizacion,
        getEVSProduccion,

        cargando,
    };
};
